import { useLocation } from "react-router-dom";

// Merkezî SEO: her rota için TEK title/description/canonical/robots üretir.
// React 19 bu etiketleri otomatik <head>'e taşır (react-helmet gerekmez).
// index.html'de bu etiketler YOKTUR — çift kayıt olmaması için tek kaynak burasıdır.

const SITE = "https://pakhizmet.com";
const DEFAULT_TITLE = "PAK — Evinizin temizliği güvenilir ellerde";
const DEFAULT_DESC =
  "PAK — Türkiye genelinde güvenilir ev ve ofis temizliği ile halı & koltuk yıkama pazaryeri. Ücretsiz talep oluşturun, doğrulanmış uzmanlardan teklif alın.";

// Sıra önemli: ilk eşleşen kullanılır. Eşleşmeyen tüm rotalar (panel/admin/hesap)
// varsayılan olarak noindex — zaten robots.txt'de de engelli.
const ROUTES = [
  {
    match: (p) => p === "/",
    title: DEFAULT_TITLE,
    desc: "Türkiye genelinde ev temizliği, ofis temizliği, halı yıkama ve yerinde koltuk yıkama. Ücretsiz talep oluşturun, doğrulanmış uzman ve firmalardan dakikalar içinde teklif alın, fiyat ve puanları karşılaştırın.",
    noindex: false,
  },
  {
    match: (p) => p === "/rezervasyon" || p.startsWith("/rezervasyon/"),
    title: "Ücretsiz Temizlik & Halı Yıkama Talebi Oluştur | PAK",
    desc: "Ev temizliği, ofis temizliği, halı yıkama veya yerinde koltuk yıkama için ücretsiz talep oluşturun; doğrulanmış uzman ve firmalardan fiyat teklifi alın, karşılaştırıp seçin.",
    noindex: false,
  },
  { match: (p) => p === "/giris", title: "Giriş Yap | PAK", desc: DEFAULT_DESC, noindex: true },
  { match: (p) => p === "/kayit", title: "Kayıt Ol | PAK", desc: DEFAULT_DESC, noindex: true },
];

export default function RouteSeo() {
  const { pathname } = useLocation();
  // Yerel açılış sayfaları (/hizmet/...) metadata'yı kendi içinde (çözülen il/ilçe
  // adıyla) yönetir → burada üretme, çift olmasın.
  if (pathname.startsWith("/hizmet/")) return null;
  const r = ROUTES.find((x) => x.match(pathname)) || {
    title: DEFAULT_TITLE,
    desc: DEFAULT_DESC,
    noindex: true,
  };
  const canonical = SITE + (pathname === "/" ? "/" : pathname.replace(/\/+$/, ""));
  return (
    <>
      <title>{r.title}</title>
      <meta name="description" content={r.desc} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={r.noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
      <meta property="og:title" content={r.title} />
      <meta property="og:description" content={r.desc} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:title" content={r.title} />
      <meta name="twitter:description" content={r.desc} />
    </>
  );
}
